import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Box, Flex } from 'components/Layout/Layout';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import H1 from 'components/H1/H1';
import Button from 'components/Button/Button';
import { ROUTE_ANALYSE_OVERVIEW } from '../../RouteList';
import {
  QUERY_GET_USERS,
  MUTATION_ARCHIVE_USER,
  MUTATION_UNARCHIVE_USER
} from '../../services/graphql';
import Mutation from 'components/Apollo/Mutation';
import P from '../../components/P/P';
import { useStores } from '../../store/useStores';
import { useQuery } from '@apollo/client';

function Users() {
  const { uiState, authStore, routing } = useStores();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const impersonate = useCallback(
    user => {
      authStore.setImpersonator(user);
      routing.push(ROUTE_ANALYSE_OVERVIEW);
    },
    [authStore, routing]
  );

  const archive = useCallback(
    (mutationFn, uid) => {
      uiState.createAlert({
        title: 'Archiveer gebruiker',
        message: 'Bent u zeker dat u deze gebruiker wilt archiveren?',
        ok: 'Archiveer',
        okHandler: async () => {
          await mutationFn({ variables: { personId: uid } });
        },
        cancel: 'Annuleer'
      });
    },
    [uiState]
  );

  const unArchive = useCallback(
    (mutationFn, uid) => {
      uiState.createAlert({
        title: 'Dearchiveer gebruiker',
        message: 'Bent u zeker dat u deze gebruiker wilt dearchiveren?',
        ok: 'Dearchiveer',
        okHandler: async () => {
          await mutationFn({ variables: { personId: uid } });
        },
        cancel: 'Annuleer'
      });
    },
    [uiState]
  );

  const columns = useMemo(
    () => [
      {
        id: 'email',
        Header: 'Email',
        accessor: d => d.email
      },
      {
        id: 'name',
        Header: 'Name',
        accessor: d => `${d.firstname} ${d.lastname}`
      },
      {
        id: 'Actions',
        Header: 'Actions',
        accessor: d => d,
        Cell: row => (
          <Flex>
            <Box mr={2}>
              <Button onClick={() => impersonate(row.value)} xSmall primary>
                impersonate
              </Button>
            </Box>
            {!row.value.archived && (
              <Box mr={2}>
                <Mutation
                  mutation={MUTATION_ARCHIVE_USER}
                  refetchQueries={[{ query: QUERY_GET_USERS }]}
                >
                  {(archivePerson, mState) => (
                    <Button
                      danger
                      xSmall
                      disabled={mState.loading}
                      onClick={() => archive(archivePerson, row.value.id)}
                    >
                      archive
                    </Button>
                  )}
                </Mutation>
              </Box>
            )}
            {row.value.archived && (
              <Box mr={2}>
                <Mutation
                  mutation={MUTATION_UNARCHIVE_USER}
                  refetchQueries={[{ query: QUERY_GET_USERS }]}
                >
                  {(unarchivePerson, mState) => (
                    <Button
                      danger
                      xSmall
                      disabled={mState.loading}
                      onClick={() => unArchive(unarchivePerson, row.value.id)}
                    >
                      unarchive
                    </Button>
                  )}
                </Mutation>
              </Box>
            )}
          </Flex>
        )
      }
    ],
    [archive, impersonate, unArchive]
  );

  const { loading, error, data } = useQuery(QUERY_GET_USERS, {
    fetchPolicy: 'cache-and-network'
  });

  if (loading) return <P>Bezig met laden...</P>;
  if (error) return <P danger>{error.message}</P>;

  const users = data?.getPersons || [];

  return (
    <Flex
      flexWrap="wrap"
      justifyContent="center"
      width={1}
      style={{ backgroundColor: 'rgb(30,100,200)' }}
      py={4}
    >
      <Box width={9 / 10}>
        <H1 small upper textcenter>
          list of Users
        </H1>

        <Box style={{ backgroundColor: 'white' }}>
          <ReactTable
            noDataText="Geen gebruikers gevonden"
            style={{ fontFamily: 'Arial, sans-serif', lineHeight: 2 }}
            data={users}
            columns={columns}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </Box>
      </Box>
    </Flex>
  );
}

export default observer(Users);
